<template>
  <div>
    <div class="toolbar">
      <el-select v-model="workTypeId" clearable placeholder="工种" style="width:180px">
        <el-option v-for="d in workTypes" :key="d.id" :label="d.dictLabel" :value="d.id" />
      </el-select>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="申请开始"
        end-placeholder="申请结束"
        style="width:260px"
      />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
    </div>
    <el-table
      :data="pageList"
      border
      v-loading="loading"
      :span-method="spanMethod"
      show-summary
      :summary-method="summaryMethod"
    >
      <el-table-column prop="workerName" label="姓名" min-width="140">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">{{ row.workerName || '-' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="workTypeName" label="工种" width="160" />
      <el-table-column prop="amount" label="小计" width="140" align="right">
        <template slot-scope="{ row }">{{ money(row.amount) }}</template>
      </el-table-column>
      <el-table-column prop="typeTotal" label="总计" width="140" align="right">
        <template slot-scope="{ row }">{{ money(row.typeTotal) }}</template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      width="900px"
      top="6vh"
      append-to-body
    >
      <el-table :data="detailList" border v-loading="detailLoading" max-height="520" show-summary :summary-method="detailSummary">
        <el-table-column prop="reqNo" label="申请单号" width="120" show-overflow-tooltip />
        <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip />
        <el-table-column prop="stageName" label="工序" width="100" show-overflow-tooltip />
        <el-table-column prop="itemName" label="事项" min-width="120" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" width="70" />
        <el-table-column prop="qty" label="数量" width="90" align="right">
          <template slot-scope="{ row }">{{ money(row.qty) }}</template>
        </el-table-column>
        <el-table-column prop="price" label="单价" width="90" align="right">
          <template slot-scope="{ row }">{{ money(row.price) }}</template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" width="110" align="right">
          <template slot-scope="{ row }">{{ money(row.amount) }}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="申请时间" width="150">
          <template slot-scope="{ row }">{{ formatDateTime(row.createdAt) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { laborCostReport, exportLaborCostReport, laborCostDetail } from '../../api/report'
import { listDictOptions } from '../../api/dict'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'
import { monthRange, money, num, downloadXlsx, formatDateTime } from './format'

export default {
  name: 'LaborCostReport',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    const range = monthRange()
    return {
      workTypeId: null,
      dateRange: [range.startDate, range.endDate],
      workTypes: [],
      list: [],
      loading: false,
      exporting: false,
      detailVisible: false,
      detailLoading: false,
      detailTitle: '',
      detailList: []
    }
  },
  computed: {
    typeSpans() {
      const list = this.pageList || []
      const spans = list.map(() => 1)
      for (let i = 0; i < list.length; i++) {
        if (i > 0 && list[i].workTypeName === list[i - 1].workTypeName) {
          spans[i] = 0
          continue
        }
        let n = 1
        for (let j = i + 1; j < list.length && list[j].workTypeName === list[i].workTypeName; j++) n++
        spans[i] = n
      }
      return spans
    }
  },
  created() {
    this.loadTypes()
    this.load()
  },
  methods: {
    money,
    formatDateTime,
    queryParams() {
      return {
        workTypeId: this.workTypeId || undefined,
        startDate: this.dateRange && this.dateRange[0],
        endDate: this.dateRange && this.dateRange[1]
      }
    },
    async loadTypes() {
      const res = await listDictOptions('WORKER_TYPE')
      this.workTypes = res.data || []
    },
    async load() {
      this.loading = true
      try {
        const res = await laborCostReport(this.queryParams())
        this.list = (res.data && res.data.list) || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportLaborCostReport(this.queryParams())
        downloadXlsx(res.data, '工人工资.xlsx')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    },
    async openDetail(row) {
      this.detailTitle = `工人工资明细 - ${row.workerName || ''}`
      this.detailVisible = true
      this.detailLoading = true
      this.detailList = []
      try {
        const res = await laborCostDetail({
          workerId: row.workerId || 0,
          workTypeId: this.workTypeId || undefined,
          startDate: this.dateRange && this.dateRange[0],
          endDate: this.dateRange && this.dateRange[1]
        })
        this.detailList = (res.data && res.data.list) || []
      } catch (e) {
        this.$message.error('加载明细失败')
      } finally {
        this.detailLoading = false
      }
    },
    spanMethod({ column, rowIndex }) {
      if (column.property !== 'workTypeName' && column.property !== 'typeTotal') return
      const span = this.typeSpans[rowIndex]
      if (!span) return { rowspan: 0, colspan: 0 }
      return { rowspan: span, colspan: 1 }
    },
    detailSummary({ columns }) {
      const data = this.detailList || []
      const amount = data.reduce((s, r) => s + num(r.amount), 0)
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        if (col.property === 'amount') return money(amount)
        return ''
      })
    },
    summaryMethod({ columns }) {
      const data = this.list || []
      const amount = data.reduce((s, r) => s + num(r.amount), 0)
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        if (col.property === 'amount' || col.property === 'typeTotal') return money(amount)
        return ''
      })
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
</style>
